/** Numbered process list (buyers / sellers guides). */
export const StepList = ({ steps, testId = "step-list" }) => (
  <ol className="relative border-l border-neutral-200" data-testid={testId}>
    {steps.map((s, i) => (
      <li key={s.title} className="group relative pb-10 pl-10 last:pb-0" data-testid={`${testId}-item-${i}`}>
        <span className="absolute -left-[17px] top-0 grid h-8 w-8 place-items-center rounded-full border border-neutral-300 bg-white font-mono text-[11px] text-neutral-600 transition-colors group-hover:border-ink group-hover:bg-ink group-hover:text-white">
          {String(i + 1).padStart(2, "0")}
        </span>
        <h3 className="text-xl font-medium text-ink">{s.title}</h3>
        <p className="mt-2 max-w-2xl text-[16px] leading-relaxed text-neutral-600">{s.body}</p>
      </li>
    ))}
  </ol>
);
